<template>
    <div>

        <MessageOverlay ref="overlay" />
        <NewOrga :display="displayNewOrga" :iduProp="this.user.id.toString()" @valid="validNewOrga" @cancel="displayNewOrga=false"  />
        <DelOrga :display="displayDelOrga" :iduProp="this.user.id.toString()" @valid="validDelOrga" @cancel="displayDelOrga=false"  />

        <v-row v-if="developer" justify="center" justify-md="start" align="center" dense class="mt-1">
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <v-btn
                    elevation="1"
                    :class="'gradient-wintech mr-5'"
                    @click="displayNewOrga=true"
                >
                    <v-icon left>mdi-office-building-plus</v-icon>
                    {{ $vuetify.lang.t('$vuetify.organization.createOrga') }}
                </v-btn>
            </v-col>
            <!-- <v-col cols="auto">
                <v-btn
                    elevation="1"
                    color="error"
                    @click="displayDelOrga=true"
                >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $vuetify.lang.t('$vuetify.organization.deleteOrga') }}
                </v-btn>
            </v-col> -->
        </v-row>

        <v-dialog
            :value="displayChangeOrga"
            max-width="700"
            @click:outside="displayChangeOrga=false"
        >
            <v-card >
                <v-card-title>
                    <span class="text-h5">{{ $vuetify.lang.t('$vuetify.organization.changeOrgaNameFrom') }}{{ originalOrganizationName }}</span>
                </v-card-title>
                <v-card-text class="px-2 px-sm-6">
                        <v-text-field
                            class="mt-5"
                            v-model="editedOrganizationName"
                            name="OrgaName"
                            label="Organization Name"
                            type="text"
                            outlined
                            required
                        ></v-text-field>

                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="editedOrganizationName == originalOrganizationName"
                                :class="{ 'gradient-wintech': (editedOrganizationName != originalOrganizationName) }"
                                @click="validateOrgaName(editedOrganizationId, editedOrganizationName)"
                            >
                                <v-icon left>mdi-content-save</v-icon>
                                {{ $vuetify.lang.t('$vuetify.organization.validate') }}
                            </v-btn>
                            <v-btn
                                color="error"
                                @click="displayChangeOrga=false"
                            >
                                <v-icon left>mdi-cancel</v-icon>
                                {{ $vuetify.lang.t('$vuetify.organization.cancel') }}
                            </v-btn>
                        </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row>
            <v-col>
                <v-card max-width="700" class="mx-auto mb-2 rounded-lg">
                    <v-card-text>
                        <v-row align="center" justify="center" class="mb-5">
                            <v-icon size="100">mdi-office-building</v-icon>
                        </v-row>
                        <v-data-table
                            :headers="headers"
                            :items="organizations"
                            item-key="name"
                            :loading="loading"
                            sort-by="name"
                        >
                            <template v-slot:[`item.favorite`]="{ item }" >
                                <template>
                                    <v-btn
                                        icon
                                        @click="favIndex !== item.id ? favIndex = item.id : favIndex = undefined"
                                    >
                                        <v-icon :color="favIndex === item.id ? '#FBC02D' : 'black'">
                                            {{ favIndex === item.id  ? 'mdi-star' : 'mdi-star-outline' }}
                                        </v-icon>
                                    </v-btn>
                                </template>
                            </template>
                            <template v-slot:[`item.name`]="{ item }">
                                    {{ item.name }}
                            </template>
                            <template v-slot:[`item.role`]="{ item }">
                                    {{ item.role }}
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <template >
                                    <v-row>
                                        <v-col >
                                            <v-icon v-if="item.role === 'ADMINISTRATION'"
                                                class="mr-2"
                                                color="black"
                                                @click="editOrganizationName(item.name, item.id)"
                                                :disabled="!item.onValidPeriod"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                        </v-col>
                                        <v-col >
                                            <v-icon v-if="item.id != user.orga"
                                                class="mr-2"
                                                color="black"
                                                @click="changeOrganization(item)"
                                            >
                                                mdi-logout-variant
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                     
                                </template>
                            </template>
                        </v-data-table>
                        
                    </v-card-text>
                    <v-card-actions class="pa-4 pt-0">
                        <v-spacer />
                        <v-btn
                            :disabled="!organizationsValuesChanged"
                            :class="!organizationsValuesChanged ? '' : 'gradient-wintech'"
                            @click="saveOrganization"
                        >
                            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-content-save</v-icon>
                            <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.organization.save') }}</template>
                        </v-btn>
                        <v-btn
                            :disabled="!organizationsValuesChanged"
                            color="error"
                            @click="resetOrganizationForm"
                        >
                            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-backup-restore</v-icon>
                            <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.organization.reset') }}</template>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import MessageOverlay from './Overlay/MessageOverlay.vue';
import NewOrga from './Organizations/NewOrganization.vue';
import DelOrga from './Organizations/DeleteOrganization.vue';
var cloneDeep = require('lodash.clonedeep');

export default {
    name: "Organization",
    components: {MessageOverlay, NewOrga, DelOrga},
    data() {
        return {
            organizations: [],
            originalOrganizations: [],
            favIndex: undefined,
            oriFavIndex: undefined,

            displayNewOrga: false,
            displayDelOrga: false,

            displayChangeOrga: false,
            editedOrganizationName: "",
            originalOrganizationName: "",
            editedOrganizationId: "",
            
            developer: false,

            headers: [
                {
                    text: 'Default',
                    class: 'table-header-text',
                    value: 'favorite',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                },
                {
                    text: 'Name',
                    class: 'table-header-text',
                    value: 'name',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                },
                {
                    text: 'Role',
                    class: 'table-header-text',
                    value: 'role',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                },
                {
                    text: 'Actions',
                    class: 'table-header-text',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                },
            ],
            loading: false,
        };
    },

    computed: {
        ...mapGetters({ user: "StateUser" }),
        
        organizationsValuesChanged() {
            return this.organizations.some((organization, i) => (organization.name !== this.originalOrganizations[i].name || this.favIndex !== this.oriFavIndex))
        },
        getNotifOrgaName(){
            let index=0;
            for(const i in this.organizations){
                if(this.organizations[i].id == this.user.orga)
                index = i;
            }
            if(this.organizations.length > index)
                return this.organizations[index].name
            
            return ""
        }
    },

    async mounted() {
        this.getOrganizations();
        this.loading = false;
    },

    methods: {
        ...mapActions(["LogOut", "ChangeGrp", "ChangeCurrentOrgaName", "ReLog"]),

        async validNewOrga() {
            this.displayNewOrga=false
            try {
                await this.ReLog({
                    email: this.user.email,
                });
                if(!this.user.orga)
                    this.$router.push("/account");
                else
                    this.$router.push("/dashboard");
                this.showError = false;
            } catch (error) {
                this.showError = true;
            }
        },
        async validDelOrga() {
            this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.utc.newDeviceOK'))
            this.displayDelOrga=false
            try {
                await this.ReLog({
                    email: this.user.email,
                });
                if(!this.user.orga)
                    this.$router.push("/account");
                else
                    this.$router.push("/dashboard");
                this.showError = false;
            } catch (error) {
                this.showError = true;
            }
            this.getOrganizations();
        },

        editOrganizationName(orgaName, orgaId){
            this.displayChangeOrga=true;
            this.editedOrganizationName=orgaName;
            this.originalOrganizationName=orgaName;
            this.editedOrganizationId=orgaId;
        },

        async changeOrganization(organization){
            this.user.orga = organization.id
            this.user.orgaName = organization.name
            this.user.orgaValid = organization.onValidPeriod
            this.user.role = organization.role
            await this.ChangeGrp(this.user)
            this.$router.push("/dashboard");
        },

        async getOrganizations() {
            if(!this.user.orga)
                return;
            
            try {
                const res = await axios.get('organizations/'+this.user.id);
                if (res.status === 200) {
                    
                    this.organizations = res.data;
                    this.originalOrganizations = cloneDeep(this.organizations);
                    for(const i in this.organizations){
                        if(this.organizations[i].favori === 1){
                            this.favIndex = this.organizations[i].id;
                            this.oriFavIndex = cloneDeep(this.favIndex);
                        }
                    }
                    
                }
            } catch (error) {
                console.error(error);
            }
            try {
                const res = await axios.get('organizations/dev/'+this.user.id);
                if (res.status === 200) {
                    this.developer = res.data.dev;
                }
            } catch (error) {
                console.error(error);
            }
        },

        validateOrgaName(orgaId, orgaName){
            for(const i in this.organizations){
                if(this.organizations[i].id === orgaId){
                    this.organizations[i].name = orgaName;
                }
            }
            this.displayChangeOrga=false;
        },
       
        async saveOrganization() {
            let currentNewOrgaName;
            for(const i in this.organizations){
                if(this.organizations[i].id === this.favIndex){
                    this.organizations[i].favori = 1;
                } else {
                    this.organizations[i].favori = 0;
                }
                if(this.organizations[i].id === this.user.orga){
                    currentNewOrgaName = this.organizations[i].name;
                }
            }

            try {
                const res = await axios.put('organizations/'+this.user.id, this.organizations);
                if (res.status == 200) {
                    this.user.orgaName = currentNewOrgaName;
                    await this.ChangeCurrentOrgaName(currentNewOrgaName);
                    this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.organization.changesOK'));
                    this.originalOrganizations = cloneDeep(this.organizations);
                    this.oriFavIndex = this.favIndex;
                }
            } catch(error) {
                // if ('response' in error && error.response.status === 409) this.isNewEmail = false;
                // else {
                //     this.$refs.overlay.showOverlay("error", error);
                // }
            }
            // this.saveAccountButtonLoading = false;
        },

        resetOrganizationForm() {
            this.organizations = cloneDeep(this.originalOrganizations);
            this.favIndex = this.oriFavIndex;
        },
    },
};
</script>
<style scoped>
.v-input--switch >>> .v-input--selection-controls__input {
    margin-right: -8px;
}
</style>